// @ts-nocheck
import validatePhone from "@insite/client-framework/Common/Utilities/validatePhone";
import siteMessage from "@insite/client-framework/SiteMessage";
import {
    chain,
    DispatchUpdateAccountSettings,
} from "@insite/client-framework/Store/Pages/AccountSettings/Handlers/UpdateAccountSettings";
import translate from "@insite/client-framework/Translate";
import {
    addToChainAfter,
    addToChainBefore,
    createChainHandler,
} from "@toolkit/Modules/client-framework/HandlerCreator";

// (as any): "props" type is hardcoded in the original handler and cannot be extended properly here.

export const ValidateAdditionalFields = createChainHandler("ValidateAdditionalFields", chain, (props: any) => {
    const firstNameTrim = props.parameter.firstName?.trim();
    props.firstNameErrorMessage = !firstNameTrim ? siteMessage("Field_Required", translate("First Name")) : "";

    const lastNameTrim = props.parameter.lastName?.trim();
    props.lastNameErrorMessage = !lastNameTrim ? siteMessage("Field_Required", translate("Last Name")) : "";

    const phone = props.parameter.phone || "";
    props.phoneErrorMessage =
        phone.trim() && !validatePhone(phone) ? siteMessage("Field_Invalid", translate("Phone")) : "";
});

addToChainBefore(chain, DispatchUpdateAccountSettings, ValidateAdditionalFields);

export const ExtendDispatchUpdateAccountSettings = createChainHandler(
    "ExtendDispatchUpdateAccountSettings",
    chain,
    (props: any) => {
        const { firstNameErrorMessage, lastNameErrorMessage, phoneErrorMessage } = props;

        props.dispatch({
            ...props.parameter,
            firstNameErrorMessage,
            lastNameErrorMessage,
            phoneErrorMessage,
            type: "Store/Pages/AccountSettings/UpdateAccountSettings",
        });
    },
);

addToChainAfter(chain, DispatchUpdateAccountSettings, ExtendDispatchUpdateAccountSettings);
